import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { Events as ScrollEvents } from "react-scroll";

import { getAccount } from "../configureStore";
import { colors, GridWrapper } from "../theme";
import { SupportContainer } from "../components/support/supportTheme";
import DonationOffer from "../components/support/SupportDonationOffer";
import SubscriptionOffer from "../components/support/SupportSubscriptionOffer";
import SocioOffer from "../components/support/SupportSocioOffer";
import SharesOffer from "../components/support/SupportSharesOffer";
import SupportFAQ from "../components/support/SupportFAQ";

const Container = styled(SupportContainer)`
  > h1 {
    font-weight: 100;

    strong {
      font-weight: 700;
    }
  }
`;

const Offers = styled.section`
  display: flex;
  justify-content: center;
  margin-top: 50px;

  @media (max-width: 1023px) {
    display: block;
  }

  > div {
    margin: 0 20px;
    padding: 30px 25px 10px;

    :first-child {
      margin-left: 0;
    }

    :last-child {
      margin-right: 0;
    }

    @media (max-width: 1599px) {
      margin: 0 5px;
    }

    @media (max-width: 1023px) {
      margin: 0 auto 60px;
      max-width: 400px;
      width: 100%;
    }

    @media (max-width: 1023px) {
      :first-child {
        margin-left: auto;
      }

      :last-child {
        margin-right: auto;
      }
    }

    > ul {
      min-height: 196px;

      @media (max-width: 1599px) {
        min-height: 230px;
      }

      @media (max-width: 1023px) {
        min-height: auto;
      }
    }
  }
`;

function SupportLanding({ account }) {
  const [selectedFAQ, setSelectedFAQ] = useState(null);

  useEffect(() => {
    ScrollEvents.scrollEvent.register("end", (to) => {
      setSelectedFAQ(to);
    });

    return () => ScrollEvents.scrollEvent.remove("end");
  }, []);

  return (
    <Container style={{ paddingTop: "25px" }}>
      <h1>
        Soutenez <strong>Le Média</strong> !
      </h1>
      <p>
        Vos soutiens sont notre unique source de financement et nous permettent
        d’innover au quotidien pour une information toujours plus qualitative.
        Écrivez l’avenir du Média avec nous en concourant au développement de
        formats exclusifs. Plus d’enquêtes, de reportages, de décryptage de
        l’actualité et d’événements physiques.
      </p>
      <GridWrapper>
        <Offers>
          <DonationOffer />
          {(!account.role || account.role === "GUEST") && (
            <SubscriptionOffer withButton />
          )}
          {(!account.active_subscription || account.role === "SUBSCRIBER") && (
            <SocioOffer
              withButton
              isResubscribing={
                account.shares_owned &&
                account.shares_owned.LEMEDIATV_SHARES_SCIC >= 5
              }
            />
          )}
          {account.active_subscription && account.role !== "SUBSCRIBER" && (
            <SharesOffer withButton />
          )}
        </Offers>
        <SupportFAQ selected={selectedFAQ} />
      </GridWrapper>
    </Container>
  );
}

SupportLanding.propTypes = {
  account: PropTypes.shape({
    role: PropTypes.string,
    active_subscription: PropTypes.object,
    shares_owned: PropTypes.shape({
      LEMEDIATV_SHARES_SCIC: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

export default connect((state) => ({ account: getAccount(state) }))(
  SupportLanding
);
